<template>
  <v-menu
    v-model="contextMenuModel"
    v-bind:target="[positionX, positionY]"
    absolute
  >
    <v-list style="overflow-y: auto">
      <!-- Set retention period -->
      <v-list-item v-if="$canControlTenantConfig()" link @click.prevent="showRetentionDialog()">
        <v-list-item-title>
          {{ $t('routes.recycleBin.setRetentionTime') }}
        </v-list-item-title>
      </v-list-item>

      <!-- Empty the recycle bin -->
      <v-list-item v-if="itemsCount > 0 && $canBelongstoTeam()" link @click.prevent="showConfirmationDialog()">
        <v-list-item-title>
          {{ $t('routes.recycleBin.emptyRecycleBin') }}
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>

  <RecycleBinSetRetentionPeriodDialog
    v-if="$canControlTenantConfig()"
    v-model="showingRetentionDialog"
    :retention-period="this.retentionPeriod"
  />

  <RecycleBinConfirmationDialog
    v-if="itemsCount > 0 && $canBelongstoTeam()"
    v-model="showingConfirmationDialog"
    type="empty"
    :in-progress="emptyRecycleBinInProgress"
    :error-message="emptyRecycleBinErrorMessage"
    @confirm="confirmEmptyRecycleBin"
  />
</template>

<script>
import { useRecycleBinStore } from '@/stores/RecycleBinStore.js'
import RecycleBinSetRetentionPeriodDialog from '@/routes/recycle-bin/components/RecycleBinSetRetentionPeriodDialog.vue';
import RecycleBinConfirmationDialog from '@/routes/recycle-bin/components/RecycleBinConfirmationDialog.vue';

export default {
  name: "RecycleBinContextMenu",
  components: {
    RecycleBinConfirmationDialog,
    RecycleBinSetRetentionPeriodDialog,
  },
  props: {
    modelValue: {
      type: Boolean,
      required: true,
    },
    positionX: {
      type: Number,
      required: true,
    },
    positionY: {
      type: Number,
      required: true,
    },
    itemsCount: {
      type: Number,
      required: true,
    },
    retentionPeriod: {
      type: Number,
      required: true,
    },
  },
  emits: ['contextMenuItemClicked', 'update:modelValue'],
  data() {
    return {
      emptyRecycleBinErrorMessage: '',
      emptyRecycleBinInProgress: false,

      showingRetentionDialog: false,
      showingConfirmationDialog: false,
    };
  },
  methods: {
    async confirmEmptyRecycleBin() {
      this.emptyRecycleBinInProgress = true;

      const recycleBinStore = useRecycleBinStore();

      try {
        await recycleBinStore.emptyRecycleBin();
        this.showingConfirmationDialog = false;
      } catch (error) {
        if (error && error.response && error.response.data && error.response.data.error) {
          this.emptyRecycleBinErrorMessage = error.response.data.error.message;
        } else {
          this.emptyRecycleBinErrorMessage = this.$t('common.generalError');
        }

        this.showingConfirmationDialog = false;
      } finally {
        this.emptyRecycleBinInProgress = false;
      }
    },
    showRetentionDialog() {
      this.showingRetentionDialog = true;
      this.$emit('contextMenuItemClicked');
    },
    showConfirmationDialog() {
      this.showingConfirmationDialog = true;
      this.$emit('contextMenuItemClicked');
    },
  },
  computed: {
    contextMenuModel: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      }
    },
  }
}
</script>

<style scoped>
.v-card__title {
  padding-top: 16px;
  padding-bottom: 16px;
}
</style>
